import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconFire: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.4 2.10002C11.1 2.00002 10.8 2.00002 10.5 2.10002C10.2 2.30002 10 2.70002 10 3.00002C10 3.00002 10 5.60002 8.3 7.30002C8 7.50002 7.8 7.80002 7.5 8.00002C5.9 9.40002 4 11.2 4 15C4 19.6 7.8 21.6 9.8 22C10.2 22.1 10.7 21.9 10.9 21.5C11.1 21.1 11 20.6 10.8 20.3C10.8 20.3 10.1 19.5 10.1 18C10.1 17.2 10.5 16.4 11 15.4C11.3 14.9 11.5 14.4 11.7 13.8C12.7 15 14 16.6 14 18C14 19.4 13.8 19.9 13.7 20.1C13.3 20.2 13 20.6 13 21C13 21.6 13.4 22 14 22H14.1C14.9 21.9 20 21.3 20 14C20 6.50002 11.8 2.30002 11.4 2.10002ZM15.9 19.3C15.9 18.9 16 18.5 16 18C16 14.6 12.1 11.5 11.6 11.2C11.4 11.1 11.2 11 11 11C10.8 11 10.7 11 10.6 11.1C10.2 11.3 10 11.6 10 12C10 12.8 9.6 13.6 9.1 14.6C8.6 15.6 8 16.8 8 18C8 18.4 8 18.8 8.1 19.1C7 18.4 6 17.1 6 15C6 12.1 7.4 10.8 8.9 9.50002C9.2 9.20002 9.4 9.00002 9.7 8.70002C11 7.40002 11.6 5.80002 11.8 4.60002C13.9 6.00002 18 9.30002 18 14C18 17.1 17 18.6 15.9 19.3Z',
    })
  )
}
